import React, {Component} from 'react';
import {Icon, Popup, Menu} from 'semantic-ui-react';

export default class FriLoader extends Component {
    render() {
        if (this.props.loading) {
            return (
                <Popup trigger={<Menu.Item>
                    <Icon loading name={"redo"}/>
                </Menu.Item>} content='Obdelujem...'/>
            );
        }
        else if(this.props.loadingText!=="")
        {
            return (
                <Popup trigger={<Menu.Item>
                    <Icon name={"delete"}/>
                </Menu.Item>}>
                    <Popup.Content>
                    {this.props.loadingText}
                    </Popup.Content>
                </Popup>
            );
        }
        else {
            return (
                <Popup trigger={<Menu.Item>
                    <Icon name={"check"}/>
                </Menu.Item>} content='Pripravljen!'/>
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/FriLoader.js